import {ref} from 'vue'
import {defineStore} from 'pinia'
import http from '@/http/http'

export const useHomeCacheStore = defineStore('homeCacheStore', () => {
    const swiperList = ref([])
    const gameAllList = ref([])

    // In-flight promises to dedupe concurrent calls (e.g. topBar + index mount together)
    let swiperLoading = null
    let gameLoading = null

    const loadSwiperList = (force = false) => {
        if (!force && swiperList.value.length > 0) return Promise.resolve()
        if (swiperLoading) return swiperLoading
        swiperLoading = http.post('sys/slideshow/loadList', {belongType: 1})
            .then(res => {
                if (res.code === 200) swiperList.value = res.data || []
            })
            .finally(() => {
                swiperLoading = null
            })
        return swiperLoading
    }

    const loadGameAllList = (force = false) => {
        if (!force && gameAllList.value.length > 0) return Promise.resolve()
        if (gameLoading) return gameLoading
        gameLoading = http.post('sys/game/loadList')
            .then(res => {
                if (res.code === 200) gameAllList.value = res.data || []
            })
            .finally(() => {
                gameLoading = null
            })
        return gameLoading
    }

    return {swiperList, gameAllList, loadSwiperList, loadGameAllList}
})
